<template>
  <div id="chat-container">
    <!-- <h3>Round: {{ this.roomData.round }}</h3> -->
    <div id="message-container">
      <div v-for="(msg, index) in messages" :key="index" class="message">
        <p class="user-name">{{ msg.user }}</p>
        <p class="user-message">{{ msg.message }}</p>
      </div>
    </div>
    <form @submit.prevent="msgHandler" id="form-container">
      <div class="input-group mb-3 my-input">
        <input
          type="text"
          class="form-control"
          placeholder="Enter The Message"
          aria-label="Recipient's username"
          aria-describedby="button-addon2"
          v-model="message"
        />
        <button class="btn btn-secondary" type="submit" id="button-addon2">
          Send
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import * as socketio from "../plugins/socketio";

export default {
  data() {
    return {
      roomId: "",
      wordToGuess: "",
      user: "",
      message: "",
      messages: [],
      roomData: "",
      hasGuessed: false,
      isMobile: false,
    };
  },

  methods: {
    msgHandler(event) {
      event.preventDefault();

      if (!this.message) {
        return false;
      }
      if (
        this.roomData.roomMaster.playerSocketId === socketio.clientSocketId() &&
        this.wordToGuess.toLowerCase() === this.message.toLowerCase()
      ) {
        socketio.sendEvent({
          type: "chatMessage",
          data: { message: "Tried to help!", roomId: this.roomId },
        });
      } else if (
        this.wordToGuess.toLowerCase() === this.message.toLowerCase() &&
        !this.hasGuessed
      ) {
        console.log("correct word detected");
        this.hasGuessed = true;
        socketio.sendEvent({
          type: "wordGuessed",
          data: {
            playerSocketId: socketio.clientSocketId(),
            roundTime: this.roomData.roundTime,
            roomId: this.roomId,
          },
        });
      } else if (
        this.wordToGuess.toLowerCase() === this.message.toLowerCase() &&
        this.hasGuessed
      ) {
        socketio.sendEvent({
          type: "chatMessage",
          data: { message: "Already Gussed!", roomId: this.roomId },
        });
      } else {
        socketio.sendEvent({
          type: "chatMessage",
          data: { message: this.message, roomId: this.roomId },
        });
      }
      this.message = "";
      document.getElementById("message-container").scrollTop =
        document.getElementById("message-container").scrollHeight + 100;
    },
  },
  mounted() {
    socketio.addEventListener({
      type: "message",
      callback: (msg) => {
        //console.log(msg)
        // if (
        //   this.roomData.roomMaster.playerSocketId != socketio.clientSocketId()
        // ) {
        //   this.messages.push(msg);

        //   console.log(msg.roomId);
        // }
        this.messages.push(msg);
      },
    });
    socketio.addEventListener({
      type: "roomState",
      callback: (roomData) => {
        this.roomId = roomData.roomId;
        this.wordToGuess = roomData.guessWord;
        this.roomData = roomData;
        if (roomData.choosingWord) {
          this.hasGuessed = false;
        }
      },
    });
  },
};
</script>

<style scoped>
#form-container {
  display: block;
  margin: auto;
}
.my-input {
  width: 300px;
  height: 60px;
  float: right;
  clear: both;
  margin-right: 20px;
  margin-top: -49px;
}
#message-container {
  background: white;
  width: 270px;
  border-radius: 10px;
  position: absolute;
  right: 30px;
  top: 167px;
  height: 370px;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
}
.user-name {
  font-family: "poppins";
  font-weight: 700;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 10px;
}
.user-message {
  font-family: "poppins";
  text-align: left;
  font-weight: 700;
  background: grey;
  color: white;
  display: inline;
  float: left;
  padding: 7px;
  border-radius: 6%;
}
.message {
  margin-left: 20px;
  display: block;
  width: 100%;
  height: 90px;
}
@media (max-width: 1200px) {
  #message-container {
    width: 25vw;
  }
  .my-input {
    width: 20vw;
    height: 40px;
  }
}
@media (max-width: 500px) {
  #chat-container {
    display: block;
    width: 100vw;
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
    background: rgba(224, 224, 224, 1);
    z-index: 3;
    touch-action: none;
    overflow: hidden;
  }
  .my-input {
    position: absolute;
    bottom: 20px;
    width: 80vw;
    left: 5vw;
  }
  #message-container {
    background: transparent;
    display: block;
    margin: auto;
    width: 90%;
  }
}
</style>
